"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventHandlingHelper = void 0;
class EventHandlingHelper {
    static handleInputEvent(eventPayload, currentEntry, handleFileUpload, handlePdfUpload, setPdfContext) {
        const { fieldName, value } = eventPayload;
        switch (fieldName) {
            case 'training-file':
                handleFileUpload(value);
                return { shouldUpdateEntry: false };
            case 'pdf-file':
                handlePdfUpload(value);
                return { shouldUpdateEntry: false };
            case 'pdf-context':
                setPdfContext(value);
                return { shouldUpdateEntry: false };
            default:
                return {
                    shouldUpdateEntry: true,
                    updatedEntry: { ...currentEntry, [fieldName]: value }
                };
        }
    }
    static createCustomEvent(eventName, detail) {
        return new CustomEvent(eventName, { detail, bubbles: true });
    }
    static dispatchEvent(element, eventName, detail) {
        element.dispatchEvent(this.createCustomEvent(eventName, detail));
    }
}
exports.EventHandlingHelper = EventHandlingHelper;
